/**
 * Label for a company dropdown option.
 * Prefers the current UI language, then any saved name, so an English-only
 * company is never rendered as a blank row.
 */
export function companyDisplayName(
  company: any,
  lang?: string | null,
  extra?: string | null,
): string {
  if (company == null || company === '') {
    return String(extra ?? '').trim();
  }

  const nested = company.company;
  const source =
    hasCompanyName(company) || !nested || typeof nested !== 'object' ? company : nested;

  const ar = text(source.company_name_ar);
  const en = text(source.company_name_en);
  const he = text(source.company_name_he);
  const other = text(source.company_name || source.name || extra);

  const order =
    lang === 'en' ? [en, ar, he, other] : lang === 'he' ? [he, en, ar, other] : [ar, en, he, other];

  const named = order.find((name) => !!name);
  if (named) return named;

  const id = source.company_id ?? company.company_id;
  return id != null && String(id).trim() !== '' ? String(id) : '';
}

function hasCompanyName(company: any): boolean {
  return !!(
    text(company?.company_name_ar) ||
    text(company?.company_name_en) ||
    text(company?.company_name_he) ||
    text(company?.company_name) ||
    text(company?.name)
  );
}

function text(value: unknown): string {
  return String(value ?? '').trim();
}
